const Colors = {
  primary: "#669966",
  stock: "#B8860B",
  mainLayoutAtiveBackground: "#e6eef6",
  mainLayoutHoverBackground: "#dfeaf6",
  mainLayoutFontColor: "#6a6d71",
  titleWithBackgroudColor: "#fff",
  titleRowWithBackgroundColor: "#669966",
  defaultPriceTable: "#EEE8AA",
  noResultBackgroud: "#EEE8AA",
  noResultFont: "#B8860B",
  muiPrimary: "#669966",
  muiDanger: "#d32f2f",
  iconButtonProductsBackground: "#C6E2FF",
  iconButtonProducts: "#4682B4",
  iconButtonDiscountsBackground: "#FFE8DC",
  iconButtonDiscounts: "#EA9E99",
  iconButtonTotalBackground: "#EAF3E7",
  iconButtonTotal: "#2A8C00",
  mainTextColor: "#4B4B4B",
};

export default Colors;
